import { HttpCase, HttpH1BForms, HttpCaseFlowInitiation } from "../Http";

export class VisaCareI140CaseAPI {

  // Reads the uploaded ETA-9089 (fileUploadId) into JSON and stores it on the
  // case. Errors are not caught here: the saga shows the message the server sent.
  public static eta9089Extract(input: any) {
    var url = "caseflowinitiation/eta9089/extract/" + input.input;
    return HttpCaseFlowInitiation.axios().get(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  // the stored (extracted / last edited) ETA-9089 JSON of an upload; 404 when none
  public static getEta9089Form(input: any) {
    var url = "caseflowinitiation/eta9089/getByFileUploadId/" + input.input;
    return HttpCaseFlowInitiation.axios().get(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  // saves the edited ETA-9089 JSON (body: the eta9089Form object) over the stored one
  public static updateEta9089Form(input: any) {
    var url = "caseflowinitiation/eta9089/update/" + input.input;
    return HttpCaseFlowInitiation.axios().put(url, input.eta9089Form, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public static i140formsCreate(input: any) {
    var url = "i140forms/createI140PetitionerDetails";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
 
        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i140formsUpdate(input: any) {
 
    var url = "i140forms/updateI140PetitionerDetails";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static getI140formsDetails(input: any) {
    var url = "i140forms/getI140PetitionerDetailsByCaseIdAndQuestionType/" + input.input.caseId +"/"+input.input.questionType;
 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpH1BForms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
    
  }

 

  public static i140FormPdfSubmit(input: any) {
 
    var url = "/caseflow/submitI140PdfGeneration/" + input.input ;
     
  //  +"?companyId="+input.input.companyCode;

    if (input === "") {
      return { data: [] };
    }      
 
  
    const resultMethod =HttpCase.axios().post(url,{
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
          return res;
    }).catch((e: any) => {
      
      return e.response;
    });

    return resultMethod;
  }

}